import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactComponent } from './contact.component';
import { AgmCoreModule } from 'angular2-google-maps/core';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { SharedModule } from '../../shared/shared.module';
import { QuoteModule } from '../../quote/quote.module';

@NgModule({
  imports: [
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAHURHxMdC3IfvYQbf11TdvccRUy8r37f0'
    }),
    SharedModule,
    QuoteModule
  ],
  declarations: [
    ContactComponent,
    ContactFormComponent
  ]
})
export class ContactModule { }



// WEBPACK FOOTER //
// ./src/app/pages/contact/contact.module.ts